import type { IObjectTableColumnsProps } from 'pages/Project/UerProject/WorkOrder/AddWorkOrderUer/helpersAndTypes';

import type { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';

import { CheckboxGridRenderer } from '../CheckboxGridRenderer';

export const useSelectingObjectColumns = ({ checkedObjects, onChangeCheckedObjects }: IObjectTableColumnsProps) => {
    const columns = useMemo<ColDef<any>[]>(
        () => [
            {
                headerName: '',
                field: 'checkbox',
                width: 55,
                resizable: false,
                pinned: 'left',
                lockPosition: 'left',
                cellClass: 'firstColumn',
                withoutPadding: true,
                spanHeaderHeight: true,
                cellRenderer: CheckboxGridRenderer,
                cellRendererParams: {
                    checkedObjects,
                    onChangeCheckedObjects,
                },
            },
            {
                headerName: 'Наименование объекта/подобъектов',
                field: 'name',
                sortable: false,
                autoHeight: true,
                flex: 1,
                width: 504,
                cellStyle: (cellParams) => ({
                    paddingLeft: `${(cellParams?.data?.level ?? 0) * 30 + 20}px`,
                }),
            },
        ],

        [checkedObjects, onChangeCheckedObjects],
    );

    return {
        columns,
    };
};
